<template>
  <div class="basket-price-list-item">
    <div class="flex-container align-justify">
      <div class="flex-container flex-dir-column align-center">
        <h3 class="basket-price-list-item__title" v-html="proposal.name" />
        <p
          v-if="proposal.details"
          class="basket-price-list-item__details"
          data-test-basket-price-list-item-details
          v-html="proposal.details"
        />
        <p
          v-if="showDigitalLabel"
          class="basket-price-list-item__campaign-line"
          data-test-basket-price-list-item-campaign-line
          v-html="digitalBonusLabel"
        />
      </div>
      <p
        v-if="formattedProposalPrice !== ''"
        class="basket-price-list-item__price"
        data-test-basket-price-list-item-price
        v-html="formattedProposalPrice"
      />
    </div>
    <div
      v-if="proposal.showYearZeroText"
      class="flex-container align-justify basket-price-list-item__disclaimer"
    >
      <div class="flex-dir-column align-center">
        <span data-test-year-zero-infant-disclaimer v-html="yearZeroText" />
        <base-info-link-modal
          class="year-zero-info"
          data-test-year-zero-text-modal
          :link-label="yearZeroModal.textLink"
          :title="yearZeroModal.title"
          :content="yearZeroModal.textContent"
          :button-label="yearZeroModal.closeBtn"
          :align-right="false"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ProposalPriceModel } from './types/ProposalPriceList';
import { formatPrice } from './utilities/basketUtilities';
import { ChildYearZeroModal } from '@/components/Feature/ProposalBasket/types/ProposalBasket';
import BaseInfoLinkModal from '@/components/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'BasketPriceListItem',
  components: {
    BaseInfoLinkModal
  },
  props: {
    proposal: {
      type: Object as PropType<ProposalPriceModel>,
      default() {
        return {
          name: '',
          type: '',
          details: '',
          isDigitallyCreated: false,
          price: 0,
          showYearZeroText: false
        };
      }
    },
    perYearLabel: {
      type: String,
      default: () => ''
    },
    digitalBonusLabel: {
      type: String,
      default: () => ''
    },
    digitalBonusTooltip: {
      type: String,
      default: () => ''
    },
    yearZeroText: {
      type: String,
      default: () => ''
    },
    yearZeroModal: {
      type: Object as PropType<ChildYearZeroModal>,
      default() {
        return {
          textLink: '',
          title: '',
          textContent: '',
          closeBtn: ''
        };
      }
    }
  },
  computed: {
    showDigitalLabel(): Boolean {
      return this.proposal.isDigitallyCreated && this.digitalBonusLabel !== '';
    },
    formattedProposalPrice(): string {
      if (this.proposal.price) return `${formatPrice(this.proposal.price)} ${this.perYearLabel}`;
      return '';
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all';

.basket-price-list-item {
  gap: rem-calc(20);
  padding: rem-calc(20) rem-calc(30);

  @include breakpoint(medium down) {
    border-bottom: 1px solid $body-background;
  }

  @include breakpoint(large up) {
    border-bottom: 1px solid $medium-gray;
  }

  &__campaign-line {
    margin: rem-calc(4) 0 0 0;
    line-height: 1.2rem;
  }

  &__title {
    line-height: 1.2rem;
    margin: 0;
  }

  &__price {
    margin: 0;
    flex-shrink: 0;

    @include breakpoint(large up) {
      align-self: center;
    }
  }

  &__details {
    margin-top: rem-calc(4);
    margin-bottom: 0;

    @include breakpoint(medium down) {
      display: none;
    }
  }

  &__disclaimer {
    margin-top: rem-calc(15);
  }
}

.year-zero-info {
  display: inline;
  margin-left: rem-calc(5);
}
</style>
@/components/Feature/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue
